import { useQuery } from "@tanstack/react-query"
import { conversationsQuery } from "../lib/conversationsQuery"

export function useConversationsQuery(...args: Parameters<typeof conversationsQuery>) {
  return useQuery(conversationsQuery(...args))
}
